import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';
import { UserService } from '@nrwl/common-lib';

@Component({
  selector: 'wizard-add-user-fusion-sso',
  templateUrl: './add.user.fusion.sso.html',
  styleUrls: ['../wizard.user.style.scss']
})
export class AddUserFusionSsoComponent implements IWizardContentComponent, OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;

  @ViewChild('currentForm') form: NgForm;

  username: string;
  name: string;
  surname: string;
  email: string;
  password: string;
  confirmPassword: string;
  passwordValidationOptions = {
    minUpperCaseChar: 1,
    minLowerCaseChar: 1,
    minSpecialChar: 1,
    minDigits: 1
  };
  private unsubscribe: Subject<void> = new Subject();
  constructor(private readonly userService: UserService) {}
  ngOnInit() {
    if (!this.userService.isActiveTestProject()) {
      this.passwordValidationOptions.minUpperCaseChar = 0;
      this.passwordValidationOptions.minLowerCaseChar = 0;
      this.passwordValidationOptions.minSpecialChar = 0;
      this.passwordValidationOptions.minDigits = 0;
    }
    this.step.form = this.form;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  userNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'userNameInput',
      key: 'username',
      newValue: this.username,
      isValid: this.form.controls.username.valid
    });
    //Adding default "user" group for new user and removing it from base.wizard.service which cause issue in other apis
    this.addDefaultGroup();
  }

  addDefaultGroup(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'groupsInput',
      key: 'groups',
      newValue: [sessionStorage.getItem('userUUID')],
      isValid: true
    });
  }

  nameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'nameInput',
      key: 'name',
      newValue: this.name,
      isValid: this.form.controls.name.valid
    });
  }

  surNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'surNameInput',
      key: 'surname',
      newValue: this.surname,
      isValid: this.form.controls.surname.valid
    });
  }

  emailUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'emailInput',
      key: 'email',
      newValue: this.email,
      isValid: this.form.controls.email.valid
    });
  }

  passwordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'passwordInput',
      key: 'password',
      newValue: this.password,
      isValid: this.form.controls.password.valid
    });
    this.confirmPasswordUpdated();
  }

  confirmPasswordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'passwordConfirmInput',
      key: 'confirmPassword',
      newValue: this.confirmPassword,
      isValid: this.form.controls.confirmPassword.valid
    });
  }

  isLoading(): boolean {
    return this.wizardCtrl.getWizardService().isLoading;
  }
}
